import React from 'react';
import PropTypes from 'prop-types';
import { FaClock } from 'react-icons/fa';
import Button from './common/Button';

const CompromissoItem = ({ pendencia, onEncerrar }) => {
  const isAtrasado = new Date() > pendencia.dataHora;
  const statusColor = isAtrasado
    ? 'bg-red-100 text-red-700'
    : 'bg-green-100 text-green-700';

  return (
    <li
      data-testid="compromisso-item"
      className={`p-4 rounded-lg shadow-lg ${statusColor} flex flex-col sm:flex-row justify-between items-start sm:items-center`}
    >
      <div className="flex items-center" data-testid="compromisso-info">
        <FaClock
          className="text-xl mr-3"
          data-testid="compromisso-clock-icon"
        />
        <div>
          <strong className="block text-lg" data-testid="compromisso-descricao">
            {pendencia.descricao}
          </strong>
          <p
            className="text-sm"
            data-testid="compromisso-data-hora"
          >{`Data e Hora: ${pendencia.dataHora.toLocaleString()}`}</p>
          <p className="text-sm" data-testid="compromisso-tipo">
            Tipo: {pendencia.tipo}
          </p>
        </div>
      </div>

      <Button
        type="confirmar"
        label="Concluir Agenda"
        onClick={() => onEncerrar(pendencia.id)}
        className="mt-3 sm:mt-0 sm:ml-4"
        ariaLabel={`Concluir compromisso: ${pendencia.descricao}`}
        data-testid="compromisso-button"
      />
    </li>
  );
};

CompromissoItem.propTypes = {
  pendencia: PropTypes.object.isRequired,
  onEncerrar: PropTypes.func.isRequired,
};

export default CompromissoItem;
